export default class TimeSpan extends Number {
    //#milliseconds = 0;
    constructor(milliseconds) {
        super(milliseconds);
    }
    get days() {
        return Math.trunc(this.totalDays);
    }
    get hours() {
        return Math.trunc(this.totalHours) % 24;
    }
    get milliseconds() {
        return Math.trunc(this.totalMilliseconds) % 1000;
    }
    get minutes() {
        return Math.trunc(this.totalMinutes) % 60;
    }
    get seconds() {
        return Math.trunc(this.totalSeconds) % 60;
    }
    get totalDays() {
        return this.totalMilliseconds / TimeSpan.day;
    }
    get totalHours() {
        return this.totalMilliseconds / TimeSpan.hour;
    }
    get totalMinutes() {
        return this.totalMilliseconds / TimeSpan.minute;
    }
    get totalSeconds() {
        return this.totalMilliseconds / TimeSpan.second;
    }
    get totalMilliseconds() {
        return this.valueOf();
    }
    add(ts) {
        return new TimeSpan(this.valueOf() + ts.valueOf());
    }
    static fromDays(value) {
        return new TimeSpan(value * TimeSpan.day);
    }
    static fromHours(value) {
        return new TimeSpan(value * TimeSpan.hour);
    }
    static fromMinutes(value) {
        return new TimeSpan(value * TimeSpan.minute);
    }
    static fromSeconds(value) {
        return new TimeSpan(value * TimeSpan.second);
    }
}
TimeSpan.second = 1000; // milliseconds
TimeSpan.minute = 60 * TimeSpan.second;
TimeSpan.hour = 60 * TimeSpan.minute;
TimeSpan.day = 24 * TimeSpan.hour;
TimeSpan.week = 7 * TimeSpan.day;
TimeSpan.zero = new TimeSpan(0);
TimeSpan.maxValue = new TimeSpan(Number.MAX_SAFE_INTEGER);
TimeSpan.minValue = new TimeSpan(Number.MIN_SAFE_INTEGER);
